import { RefObject, useLayoutEffect, useState } from 'react';
import { sheetLayoutFor } from '../../settings/sheet/SettingsSheet';
import type { SheetLayout } from '../../settings/sheet/SettingsSheet';

/**
 * Διάταξη μιας σελίδας «Πίνακας» ή ενός πίνακα: ίδια όρια και ίδιο μέτρημα με το SettingsSheet
 * (clientWidth του ίδιου του στοιχείου → wide ≥ 960, medium ≥ 640, narrow). Όχι από το παράθυρο: σε
 * οθόνες ≥768px η εφαρμογή κάνει zoom ώστε να χωρά 1366px (public/index.html), άρα ένα @media θα έκρυβε
 * στήλες σε tablet που έχει όλο τον χώρο — και ο ίδιος πίνακας μέσα σε παράθυρο έχει άλλο πλάτος.
 */
export type ListLayout = SheetLayout;

export const listLayoutFor = sheetLayoutFor;

/** Το layout του στοιχείου, ζωντανά (ResizeObserver + resize). 0 πλάτος (πριν τη μέτρηση, jsdom) = wide. */
export function useListLayout(ref: RefObject<HTMLElement | null>): ListLayout {
  const [layout, setLayout] = useState<ListLayout>('wide');
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const measure = () => setLayout(listLayoutFor(el.clientWidth));
    measure();
    const ro = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
    ro?.observe(el);
    window.addEventListener('resize', measure);
    return () => {
      ro?.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [ref]);
  return layout;
}

/** «μαρια» βρίσκει τη «Μαρία», «κουλουρι» το «ΚΟΥΛΟΎΡΙ»: χωρίς τόνους και πεζά (όπως οι Υπάλληλοι). */
export const searchKey = (s: string): string => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLocaleLowerCase('el');

/** Αναζήτηση στη μνήμη (όχι στον server): κενό ερώτημα = όλα. Τα πεδία συγκρίνονται με το searchKey. */
export const matchesSearch = (query: string, ...fields: Array<string | number | null | undefined>): boolean => {
  const q = searchKey(query.trim());
  if (!q) return true;
  return fields.some(f => f !== null && f !== undefined && searchKey(String(f)).includes(q));
};
